module.exports = __webpack_public_path__ + "img/0-25.a76a2f5d.gif";